<!--
================================================
Un composant affichant une étape du getting started

LIMITATION : À la base j'ai conçu ce composant car je ne suis pas parvenu à trier la liste des step par ordre de complétion

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div class="GettingStartedStepComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <transition name="fade">

      <div class="card" v-bind:key="name" v-bind:id="name" v-bind:class="{'stepIsDone':step.isDone}">

        <div class="card-content" v-bind:class="{'isUnfold':step.isUnfold}">
          <div class="media" v-on:click="$parent.toggleIsUnfold(step,name)">
            <div class="media-left">
                     <span>
                       <font-awesome-icon v-if="step.isUnfold" class="icon is-pulled-right chevron "
                                          :icon="['fas', 'chevron-down']"/>
                       <font-awesome-icon v-else class="icon is-pulled-right chevron "
                                          :icon="['fas', 'chevron-right']"/>
                     </span>

            </div>
            <div class="media-content">
              <div class="columns is-mobile">
                <div class="column is-narrow">
                  <p class="title" v-bind:class="{'is-done':step.isDone}">{{ step.title }} </p>
                  <p class="subtitle">{{ $tc('environXminute', step.estimatedDuration) }}</p>

                </div>
                <div class="column is-narrow">
                  <font-awesome-icon v-if="step.isDone" class="icon iconDone" :icon="['far', 'check-circle']"
                                     size="4x"/>
                  <span v-if="step.isIgnored && ! step.isDone" class="ignoredMark">{{ $t('ignoré') }}</span>
                </div>
              </div>
            </div>
          </div>

          <!------- CONTENT ----------->
          <transition name="slide">
            <div class="content" v-show="step.isUnfold">
              <div class="txt">{{ step.content.text }}
                <a v-if="step.content.knowMoreLink !=null" class="knowMore" v-bind:href="step.knowMoreLink"
                   target="_blank">en savoir plus</a></div>

              <div class="c2aBtn" v-if="step.content.c2a.text != null">
                <router-link v-bind:to="{name:step.content.c2a.route}" class="button">{{ step.content.c2a.text }}
                </router-link>
              </div>

              <a v-if="!step.isDone && !step.isIgnored" class="ignoreLink "
                 v-on:click="$parent.toggleIsIgnored(step,name)">{{ $t('ignorerPourLInstant') }}</a>
              <a v-else-if="!step.isDone && step.isIgnored" class="ignoreLink "
                 v-on:click="$parent.toggleIsIgnored(step,name)">{{ $t('nePlusIgnorer') }}</a>

            </div>
          </transition>
        </div>

      </div>

    </transition>
  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../../mixins/SentryMixin.js";
// import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import _ from 'lodash'


export default {
  name: 'GettingStartedStepComp', //utile dans vue dev tool
  mixins: [
    GlobalErrorNotification,
    SentryMixin,
    InterceptorMixin
  ],
  // components: {},

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    step: Object, // un step du GettingStartedComp
    name: String, // nom de la propriété courante dans la boucle (voir GettingStartedComp )
    index: Number, // index dans la boucle (voir GettingStartedComp )
  },

  data: function () {
    return {
      locale: this.$route.params.locale,
    }
  },

  computed: {
    ...mapState({
      // user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay

    }),

  },

  methods: {
    // demo pour déclencher le demo_event


  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
    // this.logToSentry(this, 'push a log to sentry :)', 'info')


  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
@import "../../assets/css/bulmaResponsiveDep.scss";

.GettingStartedStepComp {

  .card {
    box-shadow: none;
    border-top: solid 1px #ccc;

    .card-content {
      padding: 1.5rem;
      @include touch {
        padding: 1.2rem 1.5rem;
      }

      &.isUnfold {
        box-shadow: inset 0px 0px 4px 1px rgba(0, 1, 0, 0.2);

      }

      .media {
        cursor: pointer;
        margin: 0;

        .media-left {
          margin-right: 1.5rem;

          .icon.chevron {
            cursor: pointer;

          }
        }

        .media-content {
          position: relative;

          @include touch {
            overflow-y: hidden;
          }


          //.column{border: dashed 1px lightgreen;}
          .title {
            font-size: 1rem;
            color: #333;

            &.is-done {
              text-decoration: line-through;
              color: #999;
            }
          }

          .subtitle {
            font-size: 0.9rem;
            color: $brandThird
          }

          .iconDone {
            color: $brandPrimary;
            position: relative;

            height: 2.1rem;
            width: 2.1rem;
          }

          .ignoredMark {
            background: #eee;
            padding: 0.4rem 0.8rem;
            border-radius: 0.2rem;
            font-size: 0.85rem;
            color: $brandThird;
            font-weight: bold;
            //background: lightgreen;
            //padding: 0 !important; margin: 0 !important;
            //position: absolute; top: 1rem; right: 1.5rem;
          }
        }
      }

      .content {

        text-align: left;
        //border: saddlebrown dashed 1px;
        //padding-left: 0.3rem;
        margin: 1rem auto 0 2.2rem;

        .txt {
          margin: 1rem auto;
          color: #999;

          .knowMore {
            color: $blueHelp;
            font-weight: bold;
            font-size: 0.95rem;
            margin-left: 0.2rem;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .c2aBtn {
          .button {
            border-color: transparent;
            border-radius: 3px;
            padding: 1.2rem 1.7rem;
            font-size: 0.85rem;
            background: $brandThird;
            color: white;
          }
        }

        .ignoreLink {
          display: block;
          margin: 1.5rem auto 0;
          font-size: 0.85rem;
          color: $brandThird;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    // animation .card-content

    .slide-enter-active {
      animation: slide-down .5s;
      transform-origin: top;

    }

    .slide-leave-active {
      transform-origin: top;
      animation: slide-up 200ms;
    }

    @keyframes slide-down {
      0% {
        transform: scaleY(0);
      }
      50% {
        transform: scaleY(1.2);
      }
      100% {
        transform: scaleY(1);
      }
    }
    @keyframes slide-up {
      0% {
        transform: scaleY(1);

      }
      50% {
        //transform: scaleY(1.2);
      }
      100% {
        transform: scaleY(0);

      }
    }


  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////.
  &.darkMode {
    .card {
      background-color: $darkBg2;
      border-top: solid 1px $darkTableBorder;

      &.isUnfold {
        box-shadow: inset 0px 0px 4px 1px darken($darkBg2, 50%);

      }

      .media {
        .icon.chevron {
          color: $darkTxt !important;
        }

        .title {
          color: $darkContrastTxt !important;

          &.is-done {
            color: darken($darkTxt, 40%) !important;
          }
        }

        .subtitle {
          color: $darkLightBlue !important;
        }

        .iconDone {
          color: $darkLightBlue !important;
        }

        .ignoredMark {
          background-color: darken($darkBg2, 5%) !important;
          color: $darkLightBlue !important;
        }

      }

      .content {
        .txt {
          color: $darkTxt;

          .knowMore {
          }
        }

        .c2aBtn {
          .button {
            background-color: $brandPrimary;
            color: $darkTxtOnPrimary;
          }
        }

        .ignoreLink {
          color: $darkLightBlue;
        }
      }
    }

  }


}
</style>
